/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';

function mapStateToProps(state) {
    return({
        bootstrap: state.bootstrap
    });
}

export default function BootstrapProvider(Component) {

    class BootstrapProvider extends React.Component {
        constructor(props) {
            super(props);
        }

        render() {
            return (
                <Component
                    {...this.props}/>
            );
        }
    }

    BootstrapProvider.displayName = "BootstrapProvider";

    return connect(mapStateToProps)(BootstrapProvider);
};
